const axios = require("axios");

const ops = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_OPS_URL;
const api = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_API_URL;
const user_api = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_UAPI_URL;
const uac = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_UAC_URL;

const jumio = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_JUMIO_PROXY;
const qr = (
  process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
).REACT_APP_QR;

// export const jumioRequest = async (method = "get", requestBody, endpoint)

export const get = async (requestBody, endpoint, service = "api") => {
  const serviceUrl = defineService(service);
  let headers = {
    "Content-Type": "application/json",
  };

  let query;
  // let response;

  let response = axios({
    method: "get",
    url: `${serviceUrl}${endpoint}`,
    params: requestBody,
    headers: headers,
  })
    .then(function (res) {
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log(error.config);

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

export const getAuth = function (requestBody, endpoint, service = "api") {
  const serviceUrl = defineService(service);

  let token = `Bearer ` + getToken();
  let headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };

  let response = axios({
    method: "get",
    url: `${serviceUrl}${endpoint}`,
    params: requestBody,
    headers: headers,
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status === 401) {
          localStorage.token = "";
          return window.location.reload();
        }

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log(error.config);

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

export const post = async (requestBody, endpoint, service = "api") => {
  const serviceUrl = defineService(service);
  // let response;

  let response = await axios
    .post(`${serviceUrl}${endpoint}`, requestBody)
    .then(function (res) {
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log(error.config);

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

export const postAuth = function (requestBody, endpoint, service = "api") {
  const serviceUrl = defineService(service);

  let token = `Bearer ` + getToken();
  let headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };

  let response = axios({
    method: "post",
    url: `${serviceUrl}${endpoint}`,
    data: JSON.stringify(requestBody),
    headers: headers,
  })
    .then((res) => {
      // console.log("SUCCESS GET", response);
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status === 401) {
          localStorage.token = "";
          return window.location.reload();
        }

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log(error.config);

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

export const remove = function (requestBody, endpoint, service = "api") {
  const serviceUrl = defineService(service);

  let token;
  let headers = {};
  // if (service === "api") {
  token = `Bearer ` + getToken();
  headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };
  // }

  let response = axios({
    method: "delete",
    url: `${serviceUrl}${endpoint}`,
    data: JSON.stringify(requestBody),
    headers: headers,
  })
    .then((res) => {
      // console.log("SUCCESS GET", response);
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status === 401) {
          localStorage.token = "";
          return window.location.reload();
        }

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

export const update = function (requestBody, endpoint, service = "api") {
  const serviceUrl = defineService(service);

  let token = `Bearer ` + getToken();
  let headers = {
    "Content-Type": "application/json",
    Authorization: token,
  };

  let response = axios({
    method: "put",
    url: `${serviceUrl}${endpoint}`,
    data: JSON.stringify(requestBody),
    headers: headers,
  })
    .then((res) => {
      // console.log("SUCCESS GET", response);
      return res;
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (error.response.status === 401) {
          localStorage.token = "";
          return window.location.reload();
        }

        return { error: error.response.data, status: error.response.status };
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        return {
          error: error.request,
          status: 500,
        };
      } else {
        // Something happened in setting up the request that triggered an Error

        return {
          error: error,
          message: error.message,
        };
      }
    });

  return response;
};

const defineService = (service) => {
  let url;

  switch (service) {
    case "api":
      url = api;
      break;
    case "ops":
      url = ops;
      break;
    case "uapi":
      url = user_api;
      break;
    case "uac":
      url = uac;
      break;
    case "jumio":
      url = jumio;
      break;
    case "qr":
      url = qr;
      break;
    default:
      url = service;
  }

  return url;
};

const getToken = () => {
  return localStorage.token;
};
